import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _, { orderBy } from 'lodash'
import { AgendamentoSolicitacaoItem, DataTablePagination, Hospital } from '@/types/_'
import Apis from '@/Apis/_'

type SetSuporteModal = {
  name: string,
  value: boolean,
}

type SuporteModal = {
  alterarSituacaoSolicitacao: boolean,
}

export interface SituacaoEtapa {
  id: string,
  etapa: string,
  situacao: string,
}

@Module({ namespaced: true, name: 'SuporteAlterarSituacaoSolicitacaoStore' })
export default class SuporteAlterarSituacaoSolicitacaoStore extends VuexModule {
  // Situações não permitidas para edição...
  // public situacoesNaoPermitidas: string[] = ['AguardandoReservaHis', 'AguardandoAlteracaoDeReservaHis', 'ErroReservaHis', 'ErroAoAlterarReservaHis']
  public situacoesNaoPermitidas: string[] = []

  public hospitais: Hospital[] = []
  public hospitalId: string = ''
  public modal: SuporteModal = {
    alterarSituacaoSolicitacao: false,
  }

  @Mutation
  setModal(modal: SetSuporteModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setHospitais(value: Hospital[]) {
    this.hospitais = value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitais() {
    this.hospitais = []
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Action
  forceCast<T>(obj: any) {
    return obj
  }

  @Action({ commit: 'setHospitais' })
  async getHospitais() {
    const request = await Apis.Agendamento.SuporteApi.getHospitaisByUserCurrent()
    if (request.success) {
      const data = request.data.map((c: any) => {
        const hospital = c
        hospital.id = _.toUpper(c.id)
        hospital.nome = _.toUpper(c.nome)
        return hospital
      })
      const hospitaisCast = await this.forceCast<Hospital[]>(data)
      return hospitaisCast
    }
    return []
  }

  /** SITUACAO-ETAPA */
  public solicitacaoId: string = ''
  private statusSituacaoConfiguracaoDefault: SituacaoEtapa = {
    id: '',
    etapa: '',
    situacao: '',
  }

  public statusSituacaoConfiguracao: SituacaoEtapa = { ...this.statusSituacaoConfiguracaoDefault }

  get statusConfiguracaoDefault() {
    return this.statusSituacaoConfiguracaoDefault
  }

  public statusSituacaoEtapa: SituacaoEtapa[] = []

  @Mutation
  setSolicitacaoId(value: string) {
    this.solicitacaoId = value
  }

  @Mutation
  setStatusSituacaoConfiguracao(value: SituacaoEtapa) {
    this.statusSituacaoConfiguracao = value
  }

  @Mutation
  clearStatusSituacaoConfiguracao() {
    this.statusSituacaoConfiguracao = { ...this.statusSituacaoConfiguracaoDefault }
  }

  @Mutation
  setStatusSituacaoEtapa(value: SituacaoEtapa[]) {
    this.statusSituacaoEtapa = [
      ...value.filter((s: SituacaoEtapa) => s.etapa.toUpperCase() !== 'SOLICITACAO' && !this.situacoesNaoPermitidas.includes(s.situacao)),
    ].sort((a: SituacaoEtapa, b: SituacaoEtapa) => (a.etapa > b.etapa ? 1 : -1))
  }

  @Mutation
  clearStatusSituacaoEtapa() {
    this.statusSituacaoEtapa = []
  }

  @Action
  async getAllStatusSituacaoEtapa() {
    try {
      const request = await Apis.Agendamento.SuporteApi.getAllStatusSituacaoEtapa()
      if (request.success) this.context.commit('setStatusSituacaoEtapa', request.data as SituacaoEtapa[] || [])
      return request
    } catch (error) {
      this.context.commit('setStatusSituacaoEtapa', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertStatusDaSolicitacao() {
    try {
      const params: any = {
        solicitacaoId: this.solicitacaoId,
        statusSituacaoConfiguracao: this.statusSituacaoConfiguracao,
      }

      const request = await Apis.Agendamento.SuporteApi.upsertStatusDaSolicitacao(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** SOLICITACOES */
  private paginationSolicitacoesDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 10,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [10, 25, 50, 100],
  }

  public paginationSolicitacoes: DataTablePagination = { ...this.paginationSolicitacoesDefault }

  get paginationDefault() {
    return this.paginationSolicitacoesDefault
  }

  private solicitacoesDefault: AgendamentoSolicitacaoItem[] = []
  public solicitacoes: AgendamentoSolicitacaoItem[] = [...this.solicitacoesDefault]
  public pacienteSearch: string = ''
  public numeroAgendamentoSearch: string = ''

  @Mutation
  setPacienteSearch(value: string) {
    this.pacienteSearch = value
  }

  @Mutation
  setNumeroAgendamentoSearch(value: string) {
    this.numeroAgendamentoSearch = value
  }

  @Mutation
  setSolicitacoes(value: AgendamentoSolicitacaoItem[]) {
    this.solicitacoes = value
  }

  @Mutation
  clearSolicitacoes() {
    this.solicitacoes = [...this.solicitacoesDefault]
  }

  @Mutation
  setPaginationSolicitacoes(val: DataTablePagination) {
    this.paginationSolicitacoes = val
  }

  @Action
  async getAllSolicitacoes(pagination: DataTablePagination) {
    try {
      const params: any = {
        hospitalId: [this.hospitalId],
        etapa: 'Agendamento',
        orderBy: 'DataUltimaInteracaoAsc',
        todosOsStatus: true,
        paciente: this.pacienteSearch,
        numeroAgendamento: this.numeroAgendamentoSearch,
        pagina: pagination.page,
        qtdPorPagina: pagination.rowsPerPage,
      }

      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getAllSearch(params)
      if (request.success) {
        this.context.commit('setSolicitacoes', request.data.solicitacoes)
        this.context.commit('setPaginationSolicitacoes', {
          descending: false,
          page: pagination.page || this.paginationSolicitacoes.page,
          rowsPerPage: pagination.rowsPerPage || this.paginationSolicitacoes.rowsPerPage,
          sortBy: null,
          totalItems: request.data.totalSolicitacoes,
          rowsPerPageItems: this.paginationSolicitacoes.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('setSolicitacoes', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
